import { css } from '@emotion/react';

export const scalingWidgetStyles = css`
    margin: 1em;

    .row {
        display: flex;
        width: 100%;
        height: 20px;
        background: linear-gradient(
            to right,
            var(--color-red),
            var(--color-white),
            var(--color-green)
        );
        justify-content: space-between;
    }

    .tile {
        width: auto;
        position: relative;
        padding: 0;
    }

    .label {
        text-align: center;
    }

    .shape {
        visibility: hidden;

        &.selected {
            visibility: visible;
        }
    }

    .tile {
        .scale-cell {
            height: 20px;
        }
        .label {
            font-size: 11px;
            margin-top: 6px;
            color: var(--color-black);
        }
    }

    .shape {
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: transparent;
        border: 7px solid white;
        top: -5px;
        left: -8px;
    }
`;

export default scalingWidgetStyles;
